import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { PayrollAdminLandingService } from '../../services/payroll-admin-landing/payroll-admin-landing.service';

@Injectable({
  providedIn: 'root',
})
export class PayrollHomeRedirectGuard implements CanActivate {
  constructor(
    private payrollAdminLandingService: PayrollAdminLandingService,
    private router: Router,
  ) {}

  async canActivate(): Promise<UrlTree> {
    const nextRoute = await this.payrollAdminLandingService.getLandingRoute();

    return this.router.parseUrl(nextRoute);
  }
}
